<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        title="Employee Inbox Report"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
        :wrapper-attr="popupAttributes"
      >
        <ReportViewer
          ref="EmployeeInbox"
          :ReportName="'EmployeeInbox'"
          :ReportTitle="'Employees'"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "EmployeeInboxRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          dateFrom: String,
          dateTo: String,
          type: String,
          status: String,
          patient: Array,
          employee: Array,
          program: Array,
          noteName: Array,
          recNo: String

        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                reportParams: [],
                popupAttributes: {
                  id: 'modalEmployee'
                },
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              this.reportParams.push({ paramName: 'dateFrom', paramValue: this.dateFrom})
              this.reportParams.push({ paramName: 'dateTo', paramValue: this.dateTo})
              this.reportParams.push({ paramName: 'type', paramValue: this.type})
              this.reportParams.push({ paramName: 'status', paramValue: this.status})
              this.reportParams.push({ paramName: 'patient', paramValue: this.patient})
              this.reportParams.push({ paramName: 'employee', paramValue: this.employee})
              this.reportParams.push({ paramName: 'program', paramValue: this.program})
              this.reportParams.push({ paramName: 'noteName', paramValue: this.noteName})
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo ? this.recNo : ''})
              
              this.isReportVisible = true
              this.$refs.EmployeeInbox.buildDocument(this.reportParams)
            }
        },
        
        mounted () {
          this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
